import styled,{ createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`
    *, :after, :before {
        box-sizing:border-box;
        margin: 0;
    }

    *:focus {
        outline:none;
    }

    html, body {
        font-family:MonoLisa,Monaco,"DejaVu Sans Mono","Lucida Console",monospace;
        font-size: 14px;
        line-height: 2.027rem;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background: #121212;
        color: #EAEAEA;
    }
`;

export const Container = styled.div`
    background: #121212;
    width:100%;
    margin-left:auto;
    margin-right:auto;
    padding-left: 50px;
    padding-right: 50px;
    z-index:1;

    @media screen and (max-width: 991px){
        padding-left: 30px;
        padding-right: 30px;
    }
`;

export const NormalContainer = styled.div`
    width:100%;
    max-width:1300px;
    margin-left:auto;
    margin-right:auto;
    padding-left: 50px;
    padding-right: 50px;
    z-index:1;

    @media screen and (max-width: 991px){
        padding-left: 30px;
        padding-right: 30px;
    }
`;

export const Heading = styled.p`
    font-weight: 600;
    font-size: 4rem;
    letter-spacing: 0.5%;
    line-height: 1.5em;
    margin-bottom: 60px;

    @media screen and (max-width: 991px){
        font-size: 3.5rem;
    }

    @media screen and (max-width: 676px){
        font-size: 2.5rem;
    }
`;

export const SubHeading = styled.p`
    color: #b1b1b1;
    line-height: 2.281em;
    font-size: 1.2rem;
    margin-top: 20px;

    @media screen and (max-width: 991px){
        font-size: 1rem;
    }
`;

export const Divider = styled.hr`
    margin: 80px 0;
`;


export const MiniHeading = styled(Heading)`
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 10px;
`;

export const MiniSubHeading = styled(SubHeading)`
    font-size: 1.1rem;
    margin-top: 5px;
`;

export const Loader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
`;